module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add":"Added","remove":"Removed","packages":"Packages","volume":"Volume","grossWeight":"Gross Weight"},"no":{"add":"Laget","remove":"Slettet","packages":"Ansvarlig","volume":"Volum","grossWeight":"Brutto vekt"}}')
  delete Component.options._Ctor
}
